<brm-navigation [title]="title" [navItems]="navItems" [otherRoutes]="otherRoutes">
    <!-- We pass along the content header and footer -->
    <ng-content content-header select="[content-header]"></ng-content>
    <ng-content content-footer select="[content-footer]"></ng-content>
</brm-navigation>
